import { AuthService } from './../user/auth.service';
import { HttpClientService } from './../httpClient/httpclient.service';
import { Injectable } from '@angular/core';

@Injectable()
export class LoyaltyBalanceService {
  baseUrl = '/koncentro-loyalty';

  constructor(
    private http: HttpClientService,
    private authService: AuthService
  ) { }

  getBalance(customerId: number) {
    const company = this.authService.user.selectedCompany;
    return this.http.get(`koncentro-api/kloy/getBalancesCatalog?customerId=${customerId}&companyCode=${company}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-balance.service.ts